/**
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
'use strict';

var utils = require('../utils-10c0aec4.js');
require('@carbon/icon-helpers');
require('vue');

const CheckmarkFilled16 = utils.createSVGComponent('CheckmarkFilled16', {
  "xmlns": "http://www.w3.org/2000/svg",
  "viewBox": "0 0 16 16",
  "fill": "currentColor",
  "width": 16,
  "height": 16
}, [{
  "elem": "path",
  "attrs": {
    "d": "M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z"
  }
}, {
  "elem": "path",
  "attrs": {
    "d": "M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z",
    "data-icon-path": "inner-path",
    "opacity": "0"
  }
}]);

module.exports = CheckmarkFilled16;
